export default "__VITE_ASSET__DLQ1StTU__"